import { api } from '../../api/fetch';

export const fetchUserOrganisations = async (token: string) => {
  return await api.post(`/api/v1/organisations/invite/${token}/accept`);
};

export default fetchUserOrganisations;
